import { render, staticRenderFns } from "./DirectSettlement.vue?vue&type=template&id=2249ec1f"
import script from "./DirectSettlement.vue?vue&type=script&lang=js"
export * from "./DirectSettlement.vue?vue&type=script&lang=js"
import style0 from "./DirectSettlement.vue?vue&type=style&index=0&id=2249ec1f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports